import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [token, setToken] = useState(localStorage.getItem("anhad_token"));

  useEffect(() => {
    let active = true;
    const check = async () => {
      if (!token) {
        if (active) setUser(false);
        return;
      }
      try {
        const { data } = await api.get("/auth/me");
        if (active) setUser(data);
      } catch {
        localStorage.removeItem("anhad_token");
        if (active) {
          setToken(null);
          setUser(false);
        }
      }
    };
    check();
    return () => {
      active = false;
    };
  }, [token]);

  const persist = (tok, usr) => {
    localStorage.setItem("anhad_token", tok);
    setToken(tok);
    setUser(usr);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    persist(data.token, data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("anhad_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
